import React from 'react';
import NextHead from 'next/head';
import PropTypes from 'prop-types';

const HeadShared = ({ title, desc }) => (
  <NextHead>
    <meta charSet="UTF-8" />
    {!!title && <title>{title}</title>}
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    {!!desc && <meta name="description" content={desc} />}
    <link rel="apple-touch-icon" sizes="180x180" href="/static/favicons/apple-touch-icon.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="/static/favicons/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/static/favicons/favicon-16x16.png" />
    <link rel="manifest" href="/static/favicons/site.webmanifest" />
    <link rel="mask-icon" href="/static/favicons/safari-pinned-tab.svg" color="#e22626" />
    <meta name="msapplication-TileColor" content="#FFFFFF" />
    <meta name="theme-color" content="#e74e4e" />
    <meta name="google" content="notranslate" />
    <meta
      property="og:image"
      content="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-rpt.svg"
    />
    <link rel="dns-prefetch" href="//www.googleapis.com" />
    <link rel="dns-prefetch" href="//securetoken.googleapis.com" />
    <link rel="dns-prefetch" href="//api.rupiahtoken.com" />
  </NextHead>
);

HeadShared.defaultProps = {
  title: null,
  desc: null
};

HeadShared.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string
};

export default HeadShared;
